import axios from 'axios';
// 引入进度条
// import nprogress from 'nprogress'
// import 'nprogress/nprogress.css'
const request = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API,
    // baseURL: 'https://test.panzhihua.nhys.cdnhxx.com:9997',
    // baseURL: 'https://test.panzhihua.nhys.cdnhxx.com/union-merchants', //
    // baseURL: 'https://userinner.pzhszgh.cn/unionMerchants', // 用户
    baseURL: 'https://businessinner.pzhszgh.cn/unionMerchants', // 商家
    // baseURL: `http://192.168.5.58:9997/unionMerchants`,
    timeout: 50000
});

request.interceptors.request.use(config => {
    // 进度条开始
    // nprogress.start()
    // config：配置对象，对象里包含header请求头
    // config.headers.Authorization = this.$store.state.indexx.token
    return config;
});

// 响应拦截器
request.interceptors.response.use(
    res => {
        // 进度条结束
        // nprogress.done()
        // 成功回调函数
        return res.data;
    },
    _error => {
        // 响应失败的回调
        return Promise.reject(new Error('faile'));
    }
);

// 对外暴露
export default request;
